import { UserDrivingPermitType } from "Bands/types";
import { capitalize } from "lodash-es";
import { copy } from "shared/assets";
import { DateChangeProps, IFieldType, IFormFields } from "shared/types";

const { userDrivingPermit, errors } = copy;

export const getFormFields = ({
  handleIssueDateChange,
  handleExpiryDateChange,
  isIssueBeforeExpiry,
  isExpiryInFuture,
}: {
  handleIssueDateChange: (date: DateChangeProps) => void;
  handleExpiryDateChange: (date: DateChangeProps) => void;
  isIssueBeforeExpiry: boolean;
  isExpiryInFuture: boolean;
}): IFormFields => {
  return [
    {
      name: "issuingCountry",
      label: userDrivingPermit.fields.issuingCountry,
      type: IFieldType.country,
      validation: {
        required: errors.required,
      },
    },
    {
      name: "issuingAuthority",
      label: userDrivingPermit.fields.issuingAuthority,
      type: IFieldType.text,
    },
    {
      name: "permitNumber",
      label: userDrivingPermit.fields.permitNumber,
      type: IFieldType.text,
      validation: {
        required: errors.required,
      },
      style: {
        gridColumn: "span 2",
      },
    },
    {
      name: "issueDate",
      label: userDrivingPermit.fields.issueDate,
      type: IFieldType.datePicker,
      validation: {
        required: errors.required,
        validate: () =>
          isIssueBeforeExpiry || userDrivingPermit.messages.issueBeforeExpiry,
      },
      onChange: (value: string) => handleIssueDateChange({ date: value }),
    },
    {
      name: "expiryDate",
      label: userDrivingPermit.fields.expiryDate,
      type: IFieldType.datePicker,
      validation: {
        required: errors.required,
        validate: () =>
          isExpiryInFuture || userDrivingPermit.messages.expiryInFuture,
      },
      onChange: (value: string) => handleExpiryDateChange({ date: value }),
    },
    {
      name: "vehicleCategories",
      label: userDrivingPermit.fields.vehicleCategories,
      type: IFieldType.tagGroup,
      isMultiple: true,
      options: (
        Object.keys(UserDrivingPermitType) as Array<
          keyof typeof UserDrivingPermitType
        >
      ).map((key) => {
        const type = UserDrivingPermitType[key].replaceAll("_", "");
        const label = type.length > 3 ? capitalize(type) : type.toUpperCase();

        return {
          value: UserDrivingPermitType[key],
          label: <span>{label}</span>,
        };
      }),
      validation: {
        required: errors.required,
      },
      style: {
        gridColumn: "span 2",
      },
    },
    {
      name: "otherVehicleCategories",
      label: userDrivingPermit.fields.other,
      type: IFieldType.otherText,
      button: userDrivingPermit.fields.otherButton,
      style: {
        gridColumn: "span 2",
      },
    },
    {
      name: "files",
      label: userDrivingPermit.fields.file,
      type: IFieldType.files,
      validation: {
        required: errors.required,
      },
      style: {
        gridColumn: "span 2",
      },
    },
    {
      name: "info",
      label: userDrivingPermit.fields.info,
      type: IFieldType.rte,
      style: {
        gridColumn: "span 2",
      },
    },
  ];
};
